<template>
    <div>
        <v-container fluid class="pa-0 mt-3">
            <v-row>
                <v-col class="py-0">
                    <v-card variant="flat" tile color="#27473a">
                        <v-carousel height="220" :show-arrows="false" hide-delimiter-background hide-delimiters>
                            <v-carousel-item tile min-width="1162" aspect-ratio="0.0192307"
                                :src="imgUrl_green_with_desk_and_chair" height="100%" width="100%">
                                <div class="general-carousel-heading">
                                    <LanguagePlaceholder is-html
                                        default-text="Help Center" />
                                </div>
                                <div class="carousel-banner banner-line" style="background-color: #349e5f;"></div>
                            </v-carousel-item>
                        </v-carousel>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify="center" style="background-color: #ffffff;">
                <br>
                <br>
                <v-col cols="12"  class="d-flex justify-center">
                    <div class="general-text">
                        <br>
                        <p>
                            <LanguagePlaceholder is-html
                                default-text="Welcome to the Help Center! Here you will find all the videos, guides and FAQs you need to succeed in the RISE program." />
                        </p>
                        <br>
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="8" class="video-guides">
                    My Guides
                </v-col>
            </v-row>
            
            <v-row justify="center">
                <v-col cols="4" class="video-guides">
                    <MarketingAssetsSection heading="Partner Introduction to RISE"
                        text="Need a simple way to explain the RISE Incentive Program? This one-page overview is perfect for sharing with Dell Technologies Authorized Tier partners."
                        :items="intrductionToRiseVideoItems" />
                </v-col>
                <v-col cols="4" class="video-guides">
                    <MarketingAssetsSection heading="Partner Introductory Guide"
                        text="This presentation is designed to help you introduce the RISE Incentive Program to Dell Technologies Authorized Tier partners who haven’t yet joined. It outlines how to best position RISE in conversations with these partners and highlights why joining this market-leading program is a smart move for their business."
                        :items="partnerPresentationPdfItems" />
                </v-col>                            
            </v-row>

            <v-row justify="center">
                <v-col cols="12" sm="8" class="video-guides">
                    Video Guides
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-col cols="12" sm="8" class="video-guides">
                    
                    <v-card variant="flat" tile>
                        <v-slide-group
                            show-arrows
                            class="pa-4"
                             style="height: 310px;"
                        >
                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    width="220px"
                                    
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/Welcome To RISE Screenshot.png"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title  class="card-title">
                                    Welcome To RISE
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                    Overview of the RISE Incentive Programme
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            color="blue" 
                                            text="View"
                                            target="_blank"
                                            @click="triggerCustomEvent('showRISEVideo')"
                                            >
                                        </v-btn>
                                        
                                    </v-card-actions>
                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    width="220px"
                                
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/Redemption Screenshot.png"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title  class="card-title">
                                        Redemption
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        How to exchange your RISE rewards for E-vouchers
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            color="blue" 
                                            text="View"
                                            href="https://vimeo.com/1072131881/c73b75c2e2"
                                            target="_blank"
                                            >
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    width="220px"
                                
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/Registration Screenshot.png"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title  class="card-title">
                                        Registration
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        How to Register for RISE 
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            color="blue" 
                                            text="View"
                                            href="https://vimeo.com/1072138455/f0857555ee"
                                            target="_blank"
                                            >
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    width="220px"
                                
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/Rewards Calculator Screenshot.png"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title class="card-title">
                                        Rewards Calculator
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        Pre-calculate your earning for the quarter
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            color="blue" 
                                            text="View"
                                            href="https://vimeo.com/1060610046/5f8ecb9262"
                                            target="_blank"
                                            >
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    width="220px"
                                
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/RISE Video Assets.png"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title class="card-title">
                                        Need This in Another Language?
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        View our PDF with quick links to translated versions of this content in multiple languages
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn 
                                            color="blue" 
                                            text="View"
                                            href="https://dellpartnerincentives.com/siteassets/FAQ/RISE Video Assets.pdf"
                                            target="_blank"
                                            >
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-slide-group-item>
 
                        </v-slide-group>

                    </v-card>
                </v-col>
            </v-row>

            <!-- <v-row justify="center">
                <v-col cols="12" sm="8" class="video-guides">
                    <v-card variant="flat" tile >
                        <v-slide-group
                            show-arrows
                            class="pa-4"
                             style="height: 400px;"
                        >
                    
                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    max-width="260px"    
                                >
                                    <v-img
                                        width="300%" 
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/RiseDistributor.jpeg"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title class="card-title">
                                        Distributor Introduction to RISE
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        This one-page overview is for you! Take a quick look at how the RISE Incentive Program can help boost your bottom line.<br />&nbsp;
                                    
                                        <v-btn 
                                            variant="text"
                                            color="blue" 
                                            text="View"
                                            href="https://dellpartnerincentives.com/files/Acquisitions/Introduction to RISE PDF/Distributor Introduction to RISE.pdf"
                                            target="_blank"
                                            >
                                        </v-btn>
                                    </v-card-text>
                                    

                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    max-width="260px"    
                                >
                                    <v-img
                                        width="300%" 
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/RiseDistributor.jpeg"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title class="card-title">
                                        Distributor Introductory Guide
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        This presentation is for your own use. It introduces the RISE Incentive Program and gives you a clear, practical guide on how to encourage your partners to take part, helping you unlock more opportunities to boost your bottom line.<br />&nbsp;
                                    
                                        <v-btn 
                                            variant="text"
                                            color="blue" 
                                            text="View"
                                            href="https://dellpartnerincentives.com/files/Acquisitions/Distributor Presentation/RISE Distributor Introductory Guide.pdf"
                                            target="_blank"
                                            >
                                        </v-btn>
                                    </v-card-text>
                                    
                                  
                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    max-width="210px"    
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/RisePartner.jpeg"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title class="card-title">
                                        Partner Introduction to RISE
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        Need a simple way to explain the RISE Incentive Program? This one-page overview is perfect for sharing with Dell Technologies Authorized Tier partners.<br />&nbsp;
                                  
                                    <v-btn variant="text"
                                            color="blue" 
                                            text="View"
                                            href="https://dellpartnerincentives.com/files/Acquisitions/Introduction to RISE video/Partner Introduction to RISE EN.pdf"
                                            target="_blank"
                                            ></v-btn>
                                    </v-card-text>
                                    
                                  
                                </v-card>
                            </v-slide-group-item>

                            <v-slide-group-item>
                                <v-card
                                    class="ma-4"
                                    max-width="210px"    
                                >
                                    <v-img
                                        width="100%" height="100px"
                                        class="align-end text-white"
                                        src="https://dellpartnerincentives.com/siteassets/FAQ/RisePartner.jpeg"
                                        cover
                                        >
                                    </v-img>

                                    <v-card-title class="card-title">
                                        Partner Introductory Guide
                                    </v-card-title>

                                    <v-card-text class="card-info">
                                        This presentation is designed to help you introduce the RISE Incentive Program to Dell Technologies Authorized Tier partners who haven’t yet joined. It outlines how to best position RISE in conversations with these partners and highlights why joining this market-leading program is a smart move for their business.<br />&nbsp;
                                    
                                        <v-btn variant="text"
                                            color="blue" 
                                            text="View"
                                            href="https://dellpartnerincentives.com/files/Acquisitions/Partner Presentation/RISE Partner Introductory Guide EN.pdf"
                                            target="_blank"
                                            ></v-btn>
                                    </v-card-text>
                                  
                                </v-card>
                            </v-slide-group-item>

                        </v-slide-group>
                    </v-card>
                </v-col>
            </v-row> -->
            <v-row justify="center" style="background-color: #ffffff;">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <div class="general-text">
                        <br>
                        <br>
                        <p class="general-heading">
                            <LanguagePlaceholder is-html
                                default-text="FAQs" />
                        </p>
                        <br>
                        <p style="font-weight: 500;">
                            <LanguagePlaceholder is-html
                                default-text="Do you have a question about the Dell Performance Portal?" />
                        </p>
                        <p>
                            <LanguagePlaceholder is-html
                                default-text="Simply click on the relevant question below to find the information you require." />
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder is-html
                                default-text="If you still can't find the information you're looking for, please click <a href='mailto:support@dellpartnerincentives.com'>here</a> to contact the Dell Performance Portal Team for assistance." />
                        </p>
                        <br>
                    </div>

                    <v-expansion-panels variant="inset" class="mb-6">
                        <v-expansion-panel v-for="i in faqs" :key="i.id" color="#349e5f">
                            <v-expansion-panel-title>
                                <p class="general-text " style="font-weight: 400;">
                                    <LanguagePlaceholder is-html :default-text="i.question" />
                                </p>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-container>
                                    <p class="general-text">
                                        <LanguagePlaceholder is-html :default-text="i.answer" />
                                        <!-- <span v-html="i.answer"></span> -->
                                    </p>
                                </v-container>
                            </v-expansion-panel-text>

                        </v-expansion-panel>

                    </v-expansion-panels>
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
        </v-container>

        <v-dialog persistent v-model="showVideo" width="650" role="dialog" aria-labelledby="video-dialog-title">
            <v-card width="650">
                <v-card-title id="video-dialog-title">Welcome To Rise Video</v-card-title>
                <v-card-text>

                    <v-row style="padding:60% 0 0 0;position:relative;">
                        <iframe width="600" height="338" controls preload="none" 
                        :src="vimeoEmbedSrc"
                        frameborder="0" 
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
                        style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                        title="Welcome To RISE - Introduction video for the RISE Partner Incentive Program"
                        aria-label="Welcome To RISE video player"></iframe>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showVideo = false" aria-label="Close video dialog">
                        <LanguagePlaceholder default-text="Close" />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import imgUrl_green_with_desk_and_chair from '@/assets/img/banner/green_banner_desk_with_green_chair.jpg'
import { useSystemStore } from '@/stores/system'
import MarketingAssetsSection from '@/components/MarketingAssetsSection.vue';

const systemStore = useSystemStore()
const showVideo = ref(false);
const VIMEO_PLAYER_QUERY =
    'title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'

// Map ISO language codes (lowercase) to Vimeo video IDs.
// Fallback behavior: if a language isn't mapped, use English.
const vimeoVideoIdByLanguage = Object.freeze({
    en: '1174417709',
    // fr: 'PUT_FRENCH_VIDEO_ID_HERE',
    de: '1174423704',
    es: '1174423791',
    it: '1174423876',
    pl: '1174423961',
    tr: '1174424049',
})

const vimeoEmbedSrc = computed(() => {
    const lang = (systemStore.selectedLanguage || '').toString().toLowerCase()
    const videoId = vimeoVideoIdByLanguage[lang] || vimeoVideoIdByLanguage.en
    return `https://player.vimeo.com/video/${videoId}?${VIMEO_PLAYER_QUERY}`
})

const triggerCustomEvent = (action) => {
    if (action == 'showRISEVideo') {
        showVideo.value = true
    }
}

const faqs = ref({})

const partnerPresentationPdfItems = ref([
    { buttonText: 'English', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide EN.pdf', container: 'files' },
    { buttonText: 'French', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide FR.pdf', container: 'files' },
    { buttonText: 'German', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide DE.pdf', container: 'files' },
    { buttonText: 'Italian', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide IT.pdf', container: 'files' },
    { buttonText: 'Polish', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide PL.pdf', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide ES.pdf', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide TR.pdf', container: 'files' },
    { buttonText: 'Romanian', fileName: 'Acquisitions/Partner Presentation/RISE Partner Introductory Guide RO.pdf', container: 'files' },
    { buttonText: 'Hungarian', fileName:  'Acquisitions/Partner Presentation/RISE Partner Introductory Guide HU.pdf', container: 'files' },
    { buttonText: 'Czech', fileName:   'Acquisitions/Partner Presentation/RISE Partner Introductory Guide CS.pdf', container: 'files' },

])

const intrductionToRiseVideoItems = ref([
    { buttonText: 'English', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE EN.pdf', container: 'files' },
    { buttonText: 'French', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE FR.pdf', container: 'files' },
    { buttonText: 'German', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE DE.pdf', container: 'files' },
    { buttonText: 'Italian', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE IT.pdf', container: 'files' },
    { buttonText: 'Polish', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE PL.pdf', container: 'files' },
    { buttonText: 'Spanish', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE ES.pdf', container: 'files' },
    { buttonText: 'Turkish', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE TR.pdf', container: 'files' },
    { buttonText: 'Romanian', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE RO.pdf', container: 'files' },
    { buttonText: 'Hungarian', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE HU.pdf', container: 'files' },
    { buttonText: 'Czech', fileName: 'Acquisitions/Introduction to RISE video/Partner Introduction to RISE CS.pdf', container: 'files' },
])

onMounted(() => {
    systemStore.getFAQs().then(result => {
        if (result.success === true) {
            faqs.value = [...result.faqItems].sort((a, b) => (a.ordinal - b.ordinal) || (a.id - b.id))
        } else {
            systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
        }
    }).catch(error => {
        systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
    })
})



</script>

<style scoped>
.video-guides {
    background-color: rgb(215, 242, 195);
}

.card-title {
    font-weight: bold;
    font-size: 11px;
}
.card-info {
    font-size: 11px;
}
</style>